var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('section',[_c('HorizontalNav',{attrs:{"navs":_vm.tabs,"disabled":false}})],1),_c('section',{staticClass:"w-full max-w-[700px] mx-auto px-4 lg:px-0",attrs:{"id":"holder"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }